// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__CpwfL"};